<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            EDIT - ANIMAL DISEASE DETAIL
            </h2>
          <!--<p>Edit animal disease detail</p>-->
          <!--<a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>-->
          </div>
      </div>
      <br>
       <form class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name" >Disease Name</label>
            <input type="text" name="DiseaseName" id="DiseaseName"  value="" class="form-control">
            </div>
         </div>
         <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name" >Drug Name</label>
            <input type="text" name="addrug" id="drugname"  value="" class="form-control">
            </div>
         </div>
  
         <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="row">
   <div class="col-lg-6 col-md-6 col-sm-6">
    <div class="form-group">
      <label for="fromage">Dose Value</label>
    <input type="number" id="dosevalue" name="adddose" class="form-control" min="0" max="50" step="1">
  </div>
  </div>
   <div class="col-lg-6 col-md-6 col-sm-6">
    <div class="form-group">
      <label for="toage">Units</label>
    <input type="text" id="unit" name="adddose"  class="form-control" >
   </div>
   </div>
   </div>
</div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Date Of Discovery</label>
          <input type="date" name="DiscoveryDate" id="DiscoveryDate"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Treatment Given</label>
          <input type="text" id="Treatment" name="Treatment"  class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Description</label>
          <textarea id="Description" name="Description" class="form-control"></textarea>
       </div>
    </div>     <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalDisease()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
      
     </div>
   </div>
  </div>
  
  